import React, { useEffect, useRef, useState } from 'react';
import mixpanel from 'mixpanel-browser';

import './App.css';

declare global {
  interface Window { initVal?: string }
}

type JotFormSubmit = {
  valid: boolean,
  value: string
}

const MIXPANEL_PROJECT_TOKEN = "1e3b5213d27dbade3b96c05e4477d6d1";
const MIXPANEL_PROXY_DOMAIN = "https://mixpanel-proxy-kptr6lyhjq-uc.a.run.app";

// Basic email format validation
const isValidEmail = (email: string) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

function App() {
  const [distinctId, setDistinctId] = useState<string>("");
  const [email, setEmail] = useState('');
  const [emailValid, setEmailValid] = useState<boolean>(false);
  const hasIdentifiedRef = useRef(false);
  const submitData = useRef<JotFormSubmit>({ valid: false, value: '' });

  // Always keep submitDataRef up to date
  useEffect(() => {
    submitData.current = {
      valid: emailValid,
      value: JSON.stringify({
        email,
        mixpanel_distinct_id: distinctId,
      }),
    };
  }, [email, emailValid, distinctId]);

  // Handle email changes and validation
  const onEmailChange = (value: string) => {
    setEmail(value);
    setEmailValid(isValidEmail(value));
  };

  const onEmailBlur = () => {
    if (isValidEmail(email) && !hasIdentifiedRef.current) {
      mixpanel.identify(email);
      mixpanel.people.set({ $email: email });
      mixpanel.track("jotform.email_identified", { email });
      console.log("Identified",email)
      hasIdentifiedRef.current = true;
    }
  };

  const getSaveValue = (): string => {
    return JSON.stringify({
      email,
      mixpanel_distinct_id: distinctId,
    });
  };

  // Construct up-to-date submission value
  submitData.current = {
    valid: emailValid,
    value: getSaveValue()
  };

  useEffect(() => {
    mixpanel.init(MIXPANEL_PROJECT_TOKEN, {
      api_host: MIXPANEL_PROXY_DOMAIN,
      ignore_dnt: true,
      debug: true,
      loaded: (instance) => {
        const id = instance.get_distinct_id();
        setDistinctId(id);
      },
    });

    //@ts-expect-error
    if (window.JFCustomWidget?.subscribe) {
      //@ts-expect-error
      window.JFCustomWidget.subscribe("ready", () => {
        // Only fire off start event when form has loaded
        mixpanel.track("jotform.start");

        //@ts-expect-error
        window.JFCustomWidget.subscribe("submit", () => {
          const result = submitData.current;
          console.log('Form Submit:', result);

          mixpanel.track("jotform.submitted");

          //@ts-expect-error
          window.JFCustomWidget.sendSubmit(result);
        });
      });
    }
  }, []); 

  return (
    <div className="App">
      <div style={{ display: "none"}}>
        <h4>Your Mixpanel ID</h4>
        <input
          type="text"
          readOnly
          value={distinctId}
        />
      </div>
      <div className="email-row">
        <label className="email-label">
          Your Email: <span className="required">*</span>
        </label>
        <div className="email-input">
          <div className="email-input-container">
            <input
              type="email"
              value={email}
              onChange={e => onEmailChange(e.target.value)}
              onBlur={onEmailBlur}
              className="email-input-textbox"
              placeholder="you@example.com"
            />
            <label className="help">
              We need this to contact you directly but your campaign email can be included later.
              Enter the email address we should use to contact you regarding your endorsement and other RFS updates that might happen beyond election day.
            </label>
            {email && !emailValid && (
              <p className="required">Please enter a valid email address.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
